export { DatePickerConfigService } from 'sce-ui-lib';
// #TODO-LIBRARY



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/1_SCE_CI_CD_SIT/src/app/shared/components/datepicker/datepicker-config.service.ts